


















































import { Component, Vue } from 'vue-property-decorator';
import { appModule } from '@/store/modules/ModuleApp';
import { userModule } from '@/store/modules/ModuleUser';
import Breadcrumb from '@/components/breadcrumb/index.vue';
import ErrorLog from '@/components/error-log/index.vue';
import Hamburger from '@/components/hamburger/index.vue';
import HeaderSearch from '@/components/header-search/index.vue';
import LangSelect from '@/components/lang-select/index.vue';
import Screenfull from '@/components/screenfull/index.vue';
import SizeSelect from '@/components/size-select/index.vue';

@Component({
	name: 'Navbar',
	components: {
		Breadcrumb,
		ErrorLog,
		Hamburger,
		HeaderSearch,
		LangSelect,
		Screenfull,
		SizeSelect
	}
})
/** docs */
export default class extends Vue {
	/** document hooks */
	public get sidebar(): any {
		return appModule.sidebar;
	}

	/** document hooks */
	public get device(): any {
		return appModule.device.toString();
	}

	/** document hooks */
	public get avatar(): any {
		return userModule.avatar;
	}

	/** document hooks */
	private toggleSideBar(): any {
		appModule.toggleSideBar(false);
	}

	/** document hooks */
	private async logout(): Promise<any> {
		// await userModule.logOut();
		// this.$router.push(`/login?redirect=${this.$route.fullPath}`)['catch']((err: any): any => {
		// 	console.warn(err);
		// });
	}
}
